import Component from '../Component';
import Button from './Button';
import classList from '../utils/classList';
export default class Pill extends Component {
  view(vnode) {
    return m("span", {
      className: classList('Pill', this.attrs.className)
    }, m("span", {
      className: "Pill-content"
    }, vnode.children), this.attrs.deletable && m(Button, {
      type: "button",
      className: "Button Button--icon",
      icon: "fas fa-times",
      onclick: this.attrs.ondelete
    }));
  }
}
flarum.reg.add('core', 'common/components/Pill', Pill);